export const settingsSections = [
  { id: 'appearance', title: '外观', description: '界面布局、明暗与动态效果' },
  { id: 'playback', title: '播放与音频', description: '音量、速度、音质与在线音源' },
  { id: 'lyrics', title: '歌词', description: '时间偏移、自动查词与桌面歌词' },
  { id: 'library', title: '音乐库与数据', description: 'WebDAV、备份与音频缓存' },
  { id: 'shortcuts', title: '快捷键', description: '网页内播放控制与搜索' },
] as const;

const appleWebDavSection = { id: 'webdav', title: 'WebDAV', description: '连接信息与凭据设置' } as const;

export function findSettingsSection(value: unknown, appearance?: string) {
  return typeof value === 'string' ? settingsSections.find(section => section.id === value) || (appearance === 'apple' && value === 'webdav' ? appleWebDavSection : undefined) : undefined;
}

// Keep the shared settings route and unrelated query values. The full path is
// already the host's scroll-restoration key, including browser back/forward.
export function settingsLocation(section?: unknown, currentQuery: Record<string, unknown> = {}, appearance?: string) {
  const query = { ...currentQuery };
  delete query.section;
  const target = findSettingsSection(section, appearance);
  if (target) query.section = target.id;
  if (target?.id !== 'webdav') delete query.connection;
  return { name: 'settings', query };
}
